import React, {AriaRole} from "react";
import './button.scss';

interface Props {
    label: string;
    outlined?: boolean,
    textOnly?: boolean,
    onClick?: () => void,
    className?: string,
    type?: "button" | "submit" | "reset" | undefined,
    role?: AriaRole,
    disabled?: boolean,
}

const Button = ({
    label,
    outlined = false,
    textOnly = false,
    disabled = false,
    onClick,
    className = '',
    role = 'button',
    type,
    ...rest
                }: Props) => {
    return (
        <button
            type={type ?? 'button'}
            className={[
                className,
                outlined ? 'outlined' : '',
                textOnly ? 'textOnly': '',
                disabled ? 'disabled': '',
                'button',
            ].join(' ')}
            disabled={disabled}
            onClick={() => {
                if(disabled || !onClick) return;
                onClick();
            }}

            {...rest}
        >
            <p>{label}</p>
        </button>
    );
};

export default Button;